import { IonApp, 
    IonHeader, 
    IonToolbar, 
    IonTitle,
    IonRow,
    IonContent, 
    IonFooter, 
    IonMenu,
    IonList,
    IonListHeader,
    IonMenuToggle,
    IonIcon,
    IonLabel,
    IonPage ,
    IonButtons,
    IonButton,
    IonItem } from '@ionic/react';

import '../styles/VerifyLoginComponent.css'
import '../styles/UserSignInComponent.css'
import '../styles/style.css'
import UserLogout from './UserLogoutComponent';
import React, { useEffect, useState } from 'react';
import { getMemberProfile } from "../pages/newDelivery/services/apiService"
import { ToastContainer, toast } from 'react-toastify';

function HeaderComponent (props){
    const [memberData, setMemberData] = useState({})
    const getMemberData = async () => {
      let data = await getMemberProfile()
      setMemberData(data)
    }
    useEffect(()=>{
      getMemberData()
    },[])
    
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
           
        <div className='header-wrapper'>
            <img src="img/logo.png" className="logo" />
            <UserLogout memberData={memberData.data}></UserLogout>
        </div>
       
        </>
    )
}

export default HeaderComponent